import CustomTable from '../../../../../components/table/CustomTable';
import { permissionObj } from '../../../../../Helpers/permission';
import React from 'react';
import MealsTableApp from '../Functionality/MealsTableApp';
import AddEditMeal from '../Modal/AddEditMeal';
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';
import NotInformation from '../../../../../components/NotInformation';
import ScheduleHeader from './ScheduleHeader';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * Meals component renders the meal times table along with the header, search,
 * and conditional modals for creating or editing meals.
 *
 * It uses `MealsApp` for table data, actions, and state management.
 *
 * @param {Array} selectForDelete - List of selected meal IDs for deletion.
 * @param {Function} setSelectForDelete - Function to update selected meal IDs.
 * @param {number} modified - Counter to trigger table refresh when modified.
 * @param {boolean} modified - Flag to track data modifications.
 * @param {Function} setModified - Setter used to update the `modified` flag and trigger data reloads (required).
 * @param {string} optionView - Current schedule view (shifts, meals, access codes).
 * @param {Function} handleBtnShifts - Handler to switch to shifts view.
 * @param {Function} handleBtnMeals - Handler to switch to meals view.
 * @param {Function} handleBtnAccessCode - Handler to switch to access codes view. *
 * @returns {JSX.Element} Rendered Meals component.
 */
const MealsTable = ({
    selectForDelete,
    setSelectForDelete,
    modified,
    setModified,
    optionView,
    handleBtnShifts,
    handleBtnMeals,
    handleBtnAccessCode,
    option
}) => {

    const {
        t,
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
        pagination,
        isAllChecked,
        menuModalShow,
        handleMenuModalClose,
        handleCreate,
        setBodyForExport,
        setSearchResults,
        setSearchElement,
        page,
        rowsPerPage,
        setSimpleSearch,
        search,
        setSearch,
        searchElement
    } = MealsTableApp({
        selectForDelete,
        setSelectForDelete,
        modified,
        setModified,
        option
    });

    return (
        <>
            <ScheduleHeader
                optionView={optionView}
                handleBtnShifts={handleBtnShifts}
                handleBtnMeals={handleBtnMeals}
                handleBtnAccessCode={handleBtnAccessCode}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                page={page}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                DEV={DEV}
                permission={permission}
            />
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={DEV || permission?.includes(permissionObj?.WEB_FOODIE_MEAL_TIME_DELETE)}
                checkboxTitle={'de_/_select_all'}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                thead={thead}
                tbody={tbody}
                columnActions={
                    DEV ||
                    permission?.includes(permissionObj?.WEB_FOODIE_MEAL_TIME_DELETE) ||
                    permission?.includes(permissionObj?.WEB_FOODIE_MEAL_TIME_UPDATE)
                }
                getActionsButtons={getActionsButtons}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectForDelete}
                childrenNotInformation={
                    tbody?.data?.length === 0 ? (
                        <>
                            <div className={'warning-text'}>
                                {!searchElement && (
                                <p>{t('you_have_not_created_service_time_yet')}</p>
                                )}
                            </div>
                            {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_MEAL_TIME_CREATE)) && (
                                <CustomButtonLink
                                    className={'d-block'}
                                    splitName={false}
                                    id={'btn_me_create_service_time'}
                                    card={true}
                                    onClick={() => {
                                        handleCreate();
                                    }}
                                    name='add_new_service_time'
                                />
                            )}
                        </>
                    ) : undefined
                }
            />
            {pagination()}

        {menuModalShow &&
            <AddEditMeal
                show={menuModalShow}
                onHide={() => { handleMenuModalClose() }}
                setModified={setModified}
            />
        }

    </>)
}
export default MealsTable;
